/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountFeatureRequirement {
    getFixupPrototypeFunction() { return ServiceAccountFeatureRequirement.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountFeatureRequirement>): ServiceAccountFeatureRequirement {
        let obj = Object.assign(new ServiceAccountFeatureRequirement(), model);
        ServiceAccountFeatureRequirement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountFeatureRequirement>): ServiceAccountFeatureRequirement {
        if (!model) return null;
        return ServiceAccountFeatureRequirement.newInstance(<ServiceAccountFeatureRequirement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountFeatureRequirement) {
        if (!obj) return;

        models.ServiceAccountFeatureRequirement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountFeatureRequirement): boolean {
        Object.setPrototypeOf(obj, ServiceAccountFeatureRequirement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.providers) {
            for (let val of this.providers) {
                models.ServiceAccountFeatureRequirementPerProvider.fixupPrototype(val);
            }
        }
    }

    /**
     * CoreStack Feature
     */
    feature: models.ServiceAccountFeature;

    /**
     * Limit to matching access types
     */
    access_type: models.CloudAccountAccessType;

    /**
     * Requirements for this feature, based on Provider
     */
    providers: Array<models.ServiceAccountFeatureRequirementPerProvider>;

    /**
     * Executor responsible for this feature
     */
    executor: models.BackgroundJobExecutor;

    /**
     * If set, managed by the system
     */
    system_only: boolean;

    /**
     * If set, allowed in any account
     */
    all_products: boolean;

}
